import React from 'react';
import Dialog from '../../components/Dialog';
import Form from '../../components/Form';
import SignaturePad from '../../components/SignaturePad';
import DateTimeFormatter from '../../lib/DateTimeFormatter';
import Controller from '../../mixins/Controller';
import styled from 'styled-components';
const DialogStyles = styled.div`.w2ui-msg-title{
  color:rgb(255, 0, 0);}
  .w2ui-msg-body{text-align: center;}
  `;
class SafteyAwarenessDialog extends React.Component {
  constructor(props, context) {
    super(props, context);
    Object.assign(this, Controller);
  }
  componentDidMount = () => {
    this.initializeMixin();
  }
  handleClose = (result) => {
    if(result.OK )
      {
       // window.open(' https://pop.technipfmc.com/sites/qhses/hse/SitePageModern/500519/duty-of-care');
        return true;
      }
    else
    return false;
  }
  openLink = (evt) => {
    evt.preventDefault();
    window.open(' https://pop.technipfmc.com/sites/qhses/hse/SitePageModern/500519/duty-of-care');
  }
  render = () => {
    const data = this.props.controller.state;
       let header = this.props.header;
      return (<DialogStyles>
        <Dialog {...this.props} header={header} width={350} height={210} id='scrap-signature-dlg' onClose={this.handleClose}>
          <Dialog.Body>
            <span ><b><a style={{  color: 'rgb(97, 63, 125)', 'font-size': 'large', }} href='https://pop.technipfmc.com/sites/qhses/hse/SitePageModern/500519/duty-of-care' onClick={this.openLink}>Together let's humanize performance by putting safety first at TechnipFMC</a></b></span>
          </Dialog.Body>
          <Dialog.OKButtons />
        </Dialog>
        </DialogStyles>
      );
  }
}
export default SafteyAwarenessDialog;